module.exports = __webpack_public_path__ + "img/point_body_p.979c01b7.svg";